<!--
 * @Author: ch3nh2
 * @Date: 2022-08-22 11:44:56
 * @LastEditors: ch3nh2
 * @LastEditTime: 2022-08-22 13:43:25
 * @FilePath: /zhy_dataview_fe/src/components/InsidePages/UserContacts.vue
 * @Description: 站内用户通讯录
-->
<template>
  <div class="user_contacts" v-loading="loading" element-loading-text="加载中...">
    <div class="address_book_search">
      <el-input v-model="filterText" class="search-input" placeholder="请输入关键字">
        <template #prefix>
          <el-icon class="el-input__icon">
            <search />
          </el-icon>
        </template>
      </el-input>
    </div>
    <el-tree show-checkbox :data="data" :filter-node-method="filterNode" ref="userContacts" node-key="id"
      @check="handleCheck">
      <template #default="{ data }">
        <span class="custom-tree-node">{{ data.userName }}</span>
      </template>
    </el-tree>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons";
export default {
  name: "UserContacts",
  components: {
    Search
  },
  data() {
    return {
      data: [],
      loading: false,
      filterText: "",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.userContacts.filter(val);
    },
  },
  computed: {},
  props: {

  },
  methods: {
    getContacts() {
      this.loading = true
      this.$api.userList().then((res) => {
        const { data, code } = res;
        if (code == 'B200') {
          this.data = data
        }
        this.loading = false
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.userName.indexOf(value) !== -1;
    },
    handleCheck() {
      const nodes = this.$refs.userContacts.getCheckedNodes();
      this.$emit("checkedNodes", nodes);
    },
    removeCheck(arr) {
      this.$refs.userContacts.setCheckedNodes(arr);
    },
    clearCheck() {
      this.$refs.userContacts.setCheckedNodes([]);
    }
  },
  mounted() {
    this.getContacts()
  },
  created() { },
  beforeUnmount() { },
}
</script>

<style lang="scss">
.user_contacts {
  padding: 0 10px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 830px;

  .search-input {
    background: #4c556a;
    border-radius: 4px;
    margin-bottom: 5px;

    .el-input__icon {
      line-height: 44px;
    }
  }

  .el-tree {
    background-color: transparent !important;

    .el-tree-node__content {
      height: 34px;
      background-color: none;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1) !important;
      }

      .el-tree-node__label {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
      }

      .el-checkbox__input .el-checkbox__inner {
        background: transparent;
        border-color: rgba(255, 255, 255, 0.6);
      }

      .el-tree-node:focus {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
}

.custom-tree-node {
  font-size: 16px;
}
</style>